import { render } from "./saranaPrasarana.vue?vue&type=template&id=075a2ab6"
import script from "./saranaPrasarana.vue?vue&type=script&lang=js"
export * from "./saranaPrasarana.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__